import { StateInterface } from "./state";
import { OrganisationModel, PrivatePersonModel } from "../models";

export default {
  currentOrganisation(state: StateInterface): OrganisationModel {
    return state.organisation;
  },
  currentPrivatePerson(state: StateInterface): PrivatePersonModel {
    return state.privatePerson;
  }
};
